<template>
    <v-checkbox
        v-model="checkbox"
        :label="label"
        color="red"
        hide-details
        style="padding-left: 0px;"
        prepend-icon="mdi-help-circle"
    ></v-checkbox>
</template>

<script>
    export default {
        name : 'checkbox',

        /* >>> *************************************************************** / /* Props */
        props : {

            value : [ Boolean, null ],
            label : String

        }, // eo props{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::mounted
        *
        * Desc:
        * Note:
        *
        */
        mounted: function() {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/Checkbox.vue >>> mounted');
            this.setCheckBoxes();

        }, // eo function mounted()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data() {

            return {
                checkbox: null
            }

        }, // eo function data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Watch */
        watch : {

            value() {

                this.setCheckBoxes();

            }, // eo function value()


            checkbox(value) {

                this.$emit('input', value);

            }, // eo function checkbox()

        },// eo watch{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods : {

            /*******************************************************************
            * Setters:
            *******************************************************************/
            /*******************************************************************
            * setCheckBoxes()
            *
            * Desc:
            * Note:
            *
            */
            setCheckBoxes: function() {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/Checkbox.vue >>> setCheckBoxes');
                me.checkbox = this.value;

            }, // eo function setCheckBoxes()

        } // eo methods{}
        /* <<< ****************************************************************/

    };
</script>

<style>
    .v-input--selection-controls.v-input .v-label {
        font-size: 14px;
        font-weight: 400;
        color: #495057;
        padding-left: 5px;
    }
</style>